import React, { useEffect, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Pagination from "react-js-pagination";
import PageHeader from "../../components/common/PageHeader";
import { SocketContext } from "./../../context/actions/socket";
import UploadedFileItem from "./UploadedFileItem";
import { getQueue, archiveQueue,getDocumentsByQueueId,moveToCronJob,moveSingleDocumentToCronJob,archiveQueueDocument } from "./../../context/actions/queue";
import { downloadFiles, documentLogListing } from "../../context/actions/document";
import { queueOptions } from "./../../utils/constants";
import "./index.scss";
import NoRecord from "../../../src/components/common/NoRecord";
import SearchBlock2 from "../../../src/components/common/SearchBlock2";
import FilterDropdown from "./filters";
import { Col, Row } from "reactstrap";
import "./index.scss";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DocumentsViewModal from "./DocumentsViewModal";
import LoansViewModal from "./LoansViewModal";
import AuditLogModal from "./AuditLogModal";
import JSZip from 'jszip';

const MySwal = withReactContent(Swal);

const FileUploading = () => {
  const history = useHistory();
  const location = useLocation();
  const role = useSelector((state) => state?.user?.user?.role);
  const [userRole, setUserRole] = useState(role);

  const dispatch = useDispatch();
  const { socket,backendSocket } = useContext(SocketContext);
  const queue = useSelector((state) => state.queue);
  const user = useSelector((state) => state.user.user); // get current user details
  const { records, count,documentRecords,documentCount } = queue;

  console.log('documentRecords',documentRecords,records)
  // set active page
  const [page, setPage] = useState(location?.state?.pageNumber ? location?.state?.pageNumber : 1);
  // set active page
  const [limit] = useState(12);
  const [filter, setFilter] = useState(location?.state?.pageNumber ? 'error' : '0' );
  const [lodder, setLodder] = useState(false);
  const [isAddModelOpen, setIsModelOpen] = useState(false);
  const [isLoanModelOpen, setIsLoanModelOpen] = useState(false);
  const [isLogModelOpen, setIsLogModelOpen] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState(null);
  const [shouldResetValue, setShouldResetValue] = useState(false);
  
  const [loader, setLoader] = useState(false);
  const [docId, setDocId] = useState(null);
  const [LogPage, setLogPage] = useState(1);
  const [LogLimit, setLogLimit] = useState("5");

  const [checkedItems, setCheckedItems] = useState([]);


  
  let [queueId, setQueueId] = useState(null);
  let [loans,setLoans] = useState();
  // hook use to get queue process status and records
  useEffect(() => {
    //dispatch(getQueue({ limit: limit }))
    dispatch(getQueue({ page: page, prosessStatus: filter, limit }, (res) => {}));
    if (user) activeQueueStatus(user?.organization);
  }, [user]);

  /**
   * @description function intialization socket queue-<organization> file status realtime update
   */
  const activeQueueStatus = async (organization) => {
    console.log("organization", organization);
    console.log("socket kafka", socket);
    socket.on(`queue-${organization}`, (res) => {
      console.log('responseeee------',socket.connected,res);
      dispatch({ type: "UPDATE_QUEUE", data: res?.data });
    });
    backendSocket.on(`queue-${organization}`, (res) => {
      console.log('responseeee--', backendSocket.connected,res);
      dispatch({ type: "UPDATE_QUEUE", data: res?.data });
    });
  };
  /**
   * @description method call to update active page and call API to get respective que records
   * @param {Number} activePage accepting number
   */
  const _handlePageChange = async (activePage) => {
    setPage(activePage);
    let params = { page: activePage, prosessStatus: filter, limit }
    if(searchKeyword != null || searchKeyword !== ""){
      params.search = searchKeyword
    }
    dispatch(
      getQueue(params, (res) => {})
    );

    setCheckedItems([]);
  };

  /**
   * @description method call to update active page and call API to get respective que records
   * @param {Number} activePage accepting number
   */
  const _handleFilter = async (val) => {
    setFilter(val);
    setPage(1)
    let params = { page: 1, prosessStatus: val, limit }
    if(searchKeyword != null || searchKeyword !== ""){
      params.search = searchKeyword
    }
    dispatch(getQueue(params, (res) => {}));

    setCheckedItems([]);
  };


  const viewDocuments = async (queue) => {
    setIsModelOpen(true);
    setQueueId(queue)
    dispatch(
      getDocumentsByQueueId({ page: 1, queue:queue , limit }, (res) => {})
    );
  };


  const viewDocumentLogs = async (docId) => {
    setDocId(docId);
    setIsLogModelOpen(true);
    setQueueId(queue)
    dispatch(
      documentLogListing({ limit: LogLimit, page: LogPage, docId: docId, fields: "user", populate: 'user' }, (res) => {})
    );
  };

  const viewLoans = async (loans) => {
    setIsLoanModelOpen(true);
    console.log('loans',loans);
    setLoans(loans)
    
  };

  const downloadFile = async (queue) => {
    dispatch(downloadFiles({ queueId: queue }, (res) => {
      if (res?.blobPDFUrl?.length > 1) {
        // Create a zip file
        const zip = new JSZip();
    
        for (let i = 0; i < res?.blobPDFUrl?.length; i++) {
          const bytes = new Uint8Array(res?.blobPDFUrl[i]?.buffer?.data);
          const fileType = res?.blobPDFUrl[i]?.fileType;
    
          // Set content type based on file type
          let contentType = 'application/octet-stream'; // Default content type
    
          if (fileType === 'pdf') {
            contentType = 'application/pdf';
          } else if (fileType === 'jpg' || fileType === 'jpeg') {
            contentType = 'image/jpeg';
          } else if (fileType === 'png') {
            contentType = 'image/png';
          }
    
          const blob = new Blob([bytes], { type: contentType });
    
          // Generate a unique name for each file (e.g., using a timestamp)
          const uniqueName = `${res?.blobPDFUrl[i]?.name}-${Date.now()}.${fileType}`;
    
          // Add each file to the zip file with a unique name
          zip.file(uniqueName, blob);
        }
    
        // Generate the zip file
        zip.generateAsync({ type: 'blob' }).then((zipBlob) => {
          // Create a Blob URL for the zip file
          const zipUrl = window.URL.createObjectURL(zipBlob);
    
          // Create a link to download the zip file
          let link = document.createElement('a');
          link.href = zipUrl;
          link.download = res?.zipname.replace(/\.[^.]*$/, '') + '.zip';
    
          // Trigger a click event programmatically
          link.click();
    
          // Release the Blob URL
          window.URL.revokeObjectURL(zipUrl);
        });
      } else {
        // Download individual files if there's only one file
        for (let i = 0; i < res?.blobPDFUrl?.length; i++) {
          const bytes = new Uint8Array(res?.blobPDFUrl[i]?.buffer?.data);
          const fileType = res?.blobPDFUrl[i]?.fileType;
    
          // Set content type based on file type
          let contentType = 'application/octet-stream'; // Default content type
    
          if (fileType === 'pdf') {
            contentType = 'application/pdf';
          } else if (fileType === 'jpg' || fileType === 'jpeg') {
            contentType = 'image/jpeg';
          } else if (fileType === 'png') {
            contentType = 'image/png';
          }
    
          const blob = new Blob([bytes], { type: contentType });
    
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = res?.blobPDFUrl[i]?.name;
          link.click();
        }
      }
    }));
    
  };
  

  const _moveToCronJob = async () => {
    setIsModelOpen(false);
    dispatch(
      moveToCronJob(queueId, (res) => {})
    );
  };
  const reQueueDocument = async (queueId,documentId) => {

    MySwal.fire({
      title: "Are you sure?",
      text: "You want to requeue this document",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, requeue this document",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          moveSingleDocumentToCronJob(queueId,documentId, (res) => {
    
            if(res){
              
            }
          })
        );
        MySwal.fire("Requeued!", "Your document has been requeued again.", "success");
      }
    });
  };



  


  


  

  //method call to open/close modal
  const toggle = () => setIsModelOpen(!isAddModelOpen);
  

  /**
   * @description method call subscription details
   */
  const deleteQueue = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You want to remove from queue",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove from queue",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          archiveQueue({ id: id }, (res) => {
            dispatch(
              getQueue(
                { page: page, prosessStatus: filter, limit },
                (res) => {}
              )
            );
          })
        );
        MySwal.fire("Removed!", "Your queue has been removed from queue.", "success");
      }
    });
  };

   /**
   * @description method call subscription details
   */
   const removeQueueDocument= (queueId,documentId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You want to remove document",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove document",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          archiveQueueDocument(queueId,documentId , (res) => {
            console.log('res',res)
            if(res?.deletedQueue){
              setIsModelOpen(false);
              dispatch(
                getQueue(
                  { page: page, prosessStatus: filter, limit },
                  (res) => {}
                )
              );
          
            }
          })
        );
        MySwal.fire("Removed!", "Your document has been removed from queue.", "success");
      }
    });
  };

  const handleSearchChange = (event) => {
    setSearchKeyword(event)
    dispatch(
      getQueue({ page: 1, prosessStatus: filter, limit, search: event }, (res) => {
        setPage(1)
        setShouldResetValue(false);
      // console.log(res)
    }));
    setCheckedItems([]);
  }

  const resetSearch = () => {
    setSearchKeyword(null);
    setPage(1);
    setFilter(location?.state?.pageNumber ? 'error' : '0');
    setShouldResetValue(true);
    dispatch(getQueue({ page: 1, prosessStatus: location?.state?.pageNumber ? 'error' : '0', limit }, (res) => {}));
    setCheckedItems([]);
 
  };

  const handleLimit = (val) => {
    setLogLimit(val);
    setLogPage(1);
    dispatch(documentLogListing({ limit: val, docId: docId, fields: "user", populate: 'user', }, (res) => {
        setLoader(false)
    })) // brings DocumentL
  };

  const handlePageChange = async (activePage) => {
    setPage(activePage)
    dispatch(documentLogListing({ page: activePage, limit: LogLimit, docId: docId, fields: "user", populate: 'user' }, (res) => {
        setLoader(false)
    }))
  };

  const handleCheckboxChange = (item) => {
    setCheckedItems((prev) =>
      prev.includes(item)
        ? prev.filter((i) => i !== item)
        : [...prev, item]
    );
  };


  const _moveAllItemsToCronJob = async () => {



    MySwal.fire({
      title: "Are you sure?",
      text: "You want to try again  selected items",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
     
        for(let i = 0; i < checkedItems.length ; i++) {
          dispatch(
            moveToCronJob(checkedItems[i], (res) => {})
          );
        }
        setCheckedItems([]);
      }
    });

 
   
  };

  return (
    <>
      <div
        className={`page-wrapper d-flex flex-column flex-fill ${
          !records?.length ? "loaderOn" : ""
        }`}
      >
        <PageHeader className="filters-header">
          <div className="left-col d-inline-flex align-items-center">
            File Queue
          </div>
          <SearchBlock2 placeholder="Search File by name/ loan Number" 
          onSearchChange={handleSearchChange}
          resetValue={shouldResetValue}/>
          <button
            className="btn btn-secondary ms-2"
            onClick={resetSearch}
          >
            Reset
          </button>
          <div className="right-col ms-auto btns-col d-inline-flex">
            {/* <SearchBlock2 /> */}
           {checkedItems.length ? <button
            className="btn btn-secondary ms-2"
            onClick={() => _moveAllItemsToCronJob()}
          >
            Try Again
          </button>: '' }
            <div className="drodpdown-col d-flex align-items-center">
              {/* <SortFilterDropdown /> */}
              <FilterDropdown
                options={queueOptions}
                handleVal={_handleFilter}
                filter={filter}
              />
            </div>
          </div>
        </PageHeader>
        <div className="inner-wrapper ">
          <div className="file-uploding-wrapper">
            <Row>
              {records?.length && records?.length !== 0
                ? records.map((item, i) => (
                    <Col md="6" lg="4" className="d-flex" key={i}>

                   
                      <UploadedFileItem
                        key={i}
                        queueId={location?.state?.queueId}
                        className="flex-fill overflow-hidden"
                        queue={item}
                        _deleteQueue={(id) => {
                          deleteQueue(id);
                        }}
                        _viewDocuments={(id) => {
                          viewDocuments(id);
                        }}
                        _viewLoans={(queue)=>{
                          viewLoans(queue)

                        }}
                        _downloadFile={(queue)=>{
                          downloadFile(queue)
                        }}
                        _viewDocumentLogs={(docId)=> {
                          viewDocumentLogs(docId)
                        }}
                        checkedItems={checkedItems}

                        handleCheckboxChange={(item) => handleCheckboxChange(item)}

                        
                      />
                    </Col>
                  ))
                : records?.length === 0 && <NoRecord />}
            </Row>
          </div>
        </div>
        {/* load more */}
        <Pagination
          innerClass="pagination justify-content-end pb-10 mt-auto"
          itemClass="page-item"
          linkClass="page-link"
          prevPageText="Previous"
          nextPageText="Next"
          firstPageText="First"
          lastPageText="Last"
          activePage={page}
          itemsCountPerPage={limit}
          totalItemsCount={count}
          onChange={(activePage) => {
            _handlePageChange(activePage);
          }}
        />

        {<DocumentsViewModal
          title={'Error documents list'}
          showModel={isAddModelOpen}
          _toggle={toggle}
          filterSelected={filter}
        //  _submit={_submit}
        //  _update={_update}
        //  _detail={detail}
        //  disabled={disabled}
          lodder={lodder}
          records={documentRecords}
          count={documentCount}
          _moveToCronJob={_moveToCronJob}
          _reQueueDocument={reQueueDocument}
          _removeQueueDocument={removeQueueDocument}

        />}
         {<LoansViewModal
          title={'Loan Numbers'}
          showModel={isLoanModelOpen}
          _toggle={()=>setIsLoanModelOpen(false)}
          loans={loans}

        />}
        { isLogModelOpen && <AuditLogModal
          title={'Audit Logs'}
          showModel={isLogModelOpen}
          _toggle={()=>setIsLogModelOpen(false)}
          page={LogPage} limit={LogLimit} _handleLimit={handleLimit} _handlePageChange={handlePageChange}
        />}
      </div>
    </>
  );
};
export default FileUploading;
